"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var tslib_1 = require("tslib");

var ui_field_error_message_1 = require("@hopin-team/ui-field-error-message");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var custom_checkbox_1 = require("../styled/custom-checkbox");

var icon_1 = require("../styled/icon");

var input_1 = require("../styled/input");

var label_1 = require("../styled/label");

var Checkbox = function Checkbox(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      checked = _a.checked,
      children = _a.children,
      className = _a.className,
      disabled = _a.disabled,
      id = _a.id,
      indeterminate = _a.indeterminate,
      label = _a.label,
      name = _a.name,
      onChange = _a.onChange,
      subtitle = _a.subtitle,
      value = _a.value,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      withErrors = _a.hasErrors,
      errorMessage = _a.errorMessage,
      props = tslib_1.__rest(_a, ["__UIScope", 'data-testid', "checked", "children", "className", "disabled", "id", "indeterminate", "label", "name", "onChange", "subtitle", "value", "pattern", "hasErrors", "errorMessage"]);

  var _c = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Checkbox',
    className: className,
    __UIScope: __UIScope
  }),
      makeClasses = _c.makeClasses,
      rootClasses = _c.rootClasses;

  var _id = (0, use_id_1.useId)(id);

  var fieldsetId = "field-".concat(_id);
  var errorMsgId = "error-msg-".concat(_id);

  var _d = (0, react_1.useContext)(context_1.CheckboxContext),
      groupName = _d.groupName,
      isInverse = _d.isInverse,
      hasErrors = _d.hasErrors;

  var inversePattern = isInverse || pattern === 'inverse';
  var errors = hasErrors || withErrors;
  var a11yProps = {};

  if (errors && errorMessage) {
    a11yProps['aria-describedby'] = errorMsgId;
  }

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_flex_1.Flex, {
    className: rootClasses,
    "data-testid": testID,
    alignItems: subtitle ? 'flex-start' : 'center',
    isRelative: true
  }, react_1.default.createElement(input_1.Input, tslib_1.__assign({
    className: makeClasses('Input'),
    type: "checkbox",
    id: fieldsetId,
    name: name || groupName,
    value: value,
    onChange: onChange,
    disabled: disabled,
    checked: checked,
    hasSubtitle: Boolean(subtitle),
    hasErrors: errors,
    isInverse: inversePattern
  }, a11yProps, props)), react_1.default.createElement(custom_checkbox_1.CustomCheckbox, null, indeterminate ? react_1.default.createElement(icon_1.Icon, {
    name: "minus",
    "aria-hidden": "true"
  }) : react_1.default.createElement(icon_1.Icon, {
    name: "checkmark",
    "aria-hidden": "true"
  })), react_1.default.createElement(label_1.Label, {
    className: makeClasses('Label'),
    htmlFor: fieldsetId,
    pattern: "body",
    disabled: disabled,
    color: inversePattern ? 'grey-white' : 'grey-800'
  }, react_1.default.createElement(ui_flex_1.Flex, {
    flexDirection: subtitle ? 'column' : 'row',
    pl: 1.5
  }, children, label, subtitle && react_1.default.createElement(label_1.Subtitle, {
    className: makeClasses('Subtitle'),
    color: inversePattern ? 'grey-400' : 'grey-medium',
    pattern: "caption"
  }, subtitle)))), errors && errorMessage && react_1.default.createElement(ui_field_error_message_1.FieldErrorMessage, {
    className: makeClasses('ErrorMessage'),
    mt: 1,
    errorMessage: errorMessage,
    id: errorMsgId
  }));
};

Checkbox.displayName = 'Checkbox';
var CheckboxWithSpace = (0, ui_helper_with_space_1.withSpace)(Checkbox);
exports.Checkbox = CheckboxWithSpace;